import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const ProjectStats = ({ stats }) => {
  const statItems = [
    {
      key: 'total',
      label: 'Total Projects',
      value: stats.totalProjects,
      icon: 'Layers',
      color: 'brand-cyan',
      description: 'Completed & Live'
    },
    {
      key: 'technologies',
      label: 'Technologies',
      value: stats.technologiesUsed,
      icon: 'Code',
      color: 'brand-green',
      description: 'Mastered & Applied'
    },
    {
      key: 'clients',
      label: 'Happy Clients',
      value: stats.happyClients,
      icon: 'Users',
      color: 'brand-orange',
      description: '100% Satisfaction'
    },
    {
      key: 'uptime',
      label: 'Average Uptime',
      value: stats.averageUptime,
      icon: 'Activity',
      color: 'brand-purple',
      description: 'System Reliability'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {statItems.map((stat, index) => (
        <motion.div
          key={stat.key}
          className="glass-morphism rounded-xl p-6 cyber-border hover:cyber-glow transition-all duration-500 group"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          whileHover={{ y: -5 }}
        >
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 bg-gradient-to-br from-${stat.color} to-${stat.color}/60 rounded-lg flex items-center justify-center cyber-glow group-hover:cyber-glow-intense transition-all duration-300`}>
              <Icon name={stat.icon} size={24} color="#ffffff" />
            </div>
            <div className="text-right">
              <div className={`text-2xl font-mono font-bold text-${stat.color} group-hover:scale-110 transition-transform duration-300`}>
                {stat.value}
              </div>
            </div>
          </div>
          
          <div>
            <h3 className="font-inter font-medium text-foreground mb-1 group-hover:text-brand-cyan transition-colors duration-300">
              {stat.label}
            </h3>
            <p className="text-text-secondary text-sm">
              {stat.description}
            </p>
          </div>

          {/* Animated Progress Bar */}
          <div className="mt-4 h-1 bg-surface/50 rounded-full overflow-hidden">
            <motion.div
              className={`h-full bg-gradient-to-r from-${stat.color} to-${stat.color}/60`}
              initial={{ width: 0 }}
              animate={{ width: '100%' }}
              transition={{ delay: index * 0.2 + 0.5, duration: 1 }}
            />
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default ProjectStats;